<template>
  <div>
    <div
      v-if="product"
      class="product-showcase cursor-pointer produto-card-custom"
      :class="{ 'mx3-card-has-ribbon': faixaDesconto }"
      style="border-radius: 8px;"
    >
      <!-- Faixa de desconto (ex.: "9% DE DESCONTO"). Valores vêm da Precificação > Condições de Venda. -->
      <div class="mx3-card-ribbon" v-if="faixaDesconto" @click="openProduct">
        <span class="mx3-card-ribbon-pct">{{ faixaDesconto.percent }}%</span>
        <span class="mx3-card-ribbon-txt">DE DESCONTO</span>
        <span class="mx3-card-ribbon-extra" v-if="faixaDesconto.extra">{{ faixaDesconto.extra }}</span>
      </div>
      <div class="product-image">
        <img
          id="img-produto-card-list"
          @click="openProduct"
          :src="$util.getImageBackend(imagem.base64)"
          :alt="product.nome"
          @error="onImageError"
          class="img-fluid"
        />
        <!-- <div class="discount-badge">-45%</div> -->
        <!-- Selo "Amarelo Ferramentas": aparece apenas com estoque baixo -->
        <div class="product-badge-low" v-if="product.estoque > 0 && product.estoque < 5">Últimas unidades</div>
        <!-- Selos de entrega (Precificação > Condições de Venda / Condições de venda do produto) -->
        <div class="mx3-card-badges" v-if="product.estoque > 0 && (cond.expressa || cond.freteGratis)">
          <span class="mx3-card-badge mx3-card-badge-express" v-if="cond.expressa">
            <i class="bi bi-lightning-charge-fill" aria-hidden="true"></i> {{ cond.expressaLabel }}
          </span>
          <span class="mx3-card-badge mx3-card-badge-free" v-if="cond.freteGratis">
            <i class="bi bi-truck" aria-hidden="true"></i> {{ cond.freteGratisLabel }}
          </span>
        </div>
      </div>
      <div class="product-details">
        <div class="product-category-label" v-if="product.categoria">{{ product.categoria }}</div>
        <div class="product-category-label mx3-card-ph" v-else aria-hidden="true">&nbsp;</div>
        <h6 :title="product.nome" @click="openProduct" class="text-muted product-title">
          {{ product.nome }}
        </h6>
        <!-- Estrelas: só aparecem quando o produto tiver avaliação real
             (campo avaliacao / rating / nota, de 0 a 5). -->
        <!-- Clicar nas estrelas abre o produto já na aba "Avaliações". -->
        <button
          type="button"
          class="card-rating card-rating-link"
          v-if="notaAvaliacao > 0"
          :title="'Avaliação: ' + notaAvaliacao.toFixed(1) + ' de 5 - ver avaliações'"
          :aria-label="'Nota ' + notaAvaliacao.toFixed(1) + ' de 5. Ver avaliações do produto'"
          @click.stop="openProductReviews"
        >
          <i
            v-for="n in 5"
            :key="n"
            class="bi"
            :class="n <= Math.round(notaAvaliacao) ? 'bi-star-fill' : 'bi-star'"
            aria-hidden="true"
          ></i>
          <span class="card-rating-count" v-if="totalAvaliacoes > 0">({{ totalAvaliacoes }})</span>
        </button>
        <span v-else class="card-rating card-rating-link mx3-card-ph" aria-hidden="true">
          <i v-for="n in 5" :key="n" class="bi bi-star"></i>
        </span>

        <!-- Linha divisória sempre visível após o título -->
        <div class="divider-line"></div>

        <!-- Ação rápida (Lista de Desejos): não fica sobre a imagem do
             produto - ocupa sua própria linha, entre o título e o preço,
             e só aparece ao passar o mouse sobre o card (ver CSS
             .produto-card-custom:hover .wishlist-toggle-btn). -->
        <div class="card-quick-actions" v-if="!hideWishlist">
          <button
            type="button"
            class="wishlist-toggle-btn"
            :class="{ 'is-active': emDesejos }"
            @click.stop="toggleWishlist(product)"
            v-mx3-tip="emDesejos ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos'"
            :aria-label="emDesejos ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos'"
          >
            <i class="bi" :class="emDesejos ? 'bi-heart-fill' : 'bi-heart'" aria-hidden="true"></i>
          </button>
          <!-- Compartilhar (abaixo do coração) -->
          <ShareButton btn-class="wishlist-toggle-btn card-share-btn" :url="urlProduto" :title="product.nome" />
        </div>
        
        <small class="text-danger status-text" v-if="product.estoque === 0"
          >Indisponível</small
        >
        <div v-if="false" class="row" @click="openProduct">
          <div class="col pr-4 pl-4 pb-2">
            <small class="text-secondary" style="    font-size: 0.99em !important;" :title="product.descricao">
              {{ $util.abreviateText(product.descricao, 35) }}
            </small>
          </div>
        </div>

        <!-- Preço "DE" riscado + selo de percentual -->
        <div class="mx3-card-old" @click="openProduct" v-if="product.estoque > 0 && exibirPreco && cond.listPrice">
          <s class="mx3-card-old-price">R$ {{ $util.formatMoney(cond.listPrice) }}</s>
          <span class="mx3-card-off"><i class="bi bi-arrow-down" aria-hidden="true"></i> {{ cond.descontoPercent }} %</span>
        </div>
        <div
          class="text-center price-display"
          @click="openProduct"
          v-if="product.estoque > 0 && exibirPreco"
        >
          <!-- <span class="original-price">R$129</span> -->
          <h4 class="sale-price text-primary" >
            <b><small class="mx3-card-cur">R$</small> {{ $util.formatMoney(cond.precoDestaque) }}</b>
          </h4>
        </div>
        <div
          class="text-center price-display"
          @click.stop="irParaLogin"
          v-else-if="product.estoque > 0 && !exibirPreco"
        >
          <h4 class="sale-price text-primary" style="font-size: 0.9em;" >
            <b><small class="mx3-login-price-link">Faça login para ver o preço</small></b>
          </h4>
        </div>
        <!-- Condições de pagamento: Pix/Boleto e cartão parcelado -->
        <div class="mx3-card-pay" @click="openProduct" v-if="product.estoque > 0 && exibirPreco && (cond.precoPix || cond.parcelas)">
          <div class="mx3-card-pix" v-if="cond.precoPix">{{ cond.pixLabel }}</div>
          <div class="mx3-card-installments" v-if="cond.parcelas">
            <template v-if="cond.precoPix">ou </template><template v-else>à vista </template><template v-if="cond.precoPix"><strong>R$ {{ $util.formatMoney(cond.preco) }}</strong>{{ ' ' }}</template>em <strong>{{ cond.parcelas.n }}x de R$ {{ $util.formatMoney(cond.parcelas.valor) }}</strong> <template v-if="cond.parcelas.semJuros">sem juros </template>no cartão
          </div>
        </div>
      </div>
      <div class="btn-container-wrapper" style="position: relative; bottom: 0px; width: 100%; display: flex; justify-content: center;">
        <div class="btn-wrapper-adicionar">
          <div class="quantity-control" ref="qtyControl" v-if="product.estoque > 0" @click.stop>
            <button
              type="button"
              class="qty-btn qty-minus"
              @click.stop="decrementQty"
              :disabled="qty <= 1"
              aria-label="Diminuir quantidade"
            ></button>
            <input
              type="number"
              class="qty-input"
              v-model.number="qty"
              min="1"
              :max="product.estoque"
              @change="normalizarQty"
              @click.stop
              aria-label="Quantidade"
            />
            <button
              type="button"
              class="qty-btn"
              @click.stop="incrementQty"
              :disabled="qty >= product.estoque"
              aria-label="Aumentar quantidade"
            >+</button>
          </div>
          <div class="mx3-card-voltpick" v-if="escolhendoTensao && product.estoque > 0" ref="balaoTensao" @click.stop role="group" aria-label="Escolha a tensão">
            <div class="mx3-card-voltpick-title">
              <span><i class="bi bi-lightning-charge-fill" aria-hidden="true"></i> Escolha a tensão</span>
              <button type="button" class="mx3-card-voltpick-x" @click.stop="fecharBalaoTensao" aria-label="Cancelar">&times;</button>
            </div>
            <div class="mx3-card-voltpick-opts">
              <button
                v-for="o in product.tensoes"
                :key="o.voltage"
                type="button"
                class="mx3-card-voltpick-opt"
                :disabled="!(o.estoque > 0)"
                :title="o.estoque > 0 ? 'Adicionar na tensão ' + rotuloDaTensao(o.voltage) : 'Indisponível nesta tensão'"
                @click.stop="confirmarTensao(o.voltage)"
              >{{ rotuloDaTensao(o.voltage) }}</button>
            </div>
          </div>
          <b-btn
            v-if="product.estoque > 0"
            block
            id="buy-button-" 
            class="primary text-light btn-adicionar-card"
            variant="primary"
            size="sm"
            style="background: linear-gradient(135deg, var(--mx3-style-primary, #ff6600) 0, var(--mx3-style-primary-dark, #cc5200) 100%);"
            v-mx3-tip.bottom="'Adicionar ao carrinho'"
            @click="addCart(product, $event)"
            ref="btnAdicionar"
          >
            <b class="text-dark btn-text-adicionar" style="display:flex;align-items:center;justify-content:center;gap:4px;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-shopping-cart-icon lucide-shopping-cart"
              >
                <circle cx="8" cy="21" r="1" />
                <circle cx="19" cy="21" r="1" />
                <path
                  d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                />
              </svg>
              <span>Adicionar</span>
            </b>
          </b-btn>
          <b-btn
            v-else
            block
            id="notify-button-" 
            class="btn-avise-me-card"
            @click="notificarDisponibilidade"
          >
            <b class="btn-text-adicionar" style="display:flex;align-items:center;justify-content:center;gap:4px;">
              <span>Avise-me quando chegar</span>
            </b>
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carrinhoQtd from "@/services/carrinhoQtd";
import { registrarTensaoNoCarrinho, aplicarTensao, carrinhoTensao, rotuloTensao as formatarRotuloTensao } from "@/services/tensao";
import { calcularCondicoes } from "@/services/condicoesVenda";
import ShareButton from "@/components/ShareButton.vue";
import mx3Tip from "@/utils/mx3Tip";
import { duracaoBalaoTensao, modoEdicaoAtivo } from "@/services/balaoTensao";
import { avisarAdicionadoAoCarrinho } from "@/services/avisoCarrinho";

export default {
  components: { ShareButton },
  props: ["product", "hideWishlist"],
  directives: { mx3Tip },
  data() {
    return {
      // imagem: { base64: "/assets/loading2.gif" },
      qty: 1,
      // Produto nas duas tensões: o botão "Adicionar" abre a escolha entre 110 V e 220 V.
      escolhendoTensao: false,
    };
  },
  computed: {
    // "110V" | "220V" | "Bivolt" | "" (produto sem tensão cadastrada).
    rotuloTensao() {
      const v = String((this.product && this.product.voltage) || "").trim().toLowerCase();
      if (!v) return "";
      if (v.indexOf("bivolt") !== -1) return "Bivolt";
      if (/^(110|127)/.test(v)) return "110V";
      if (/^220/.test(v)) return "220V";
      return "";
    },
    // Nota real do produto (0 a 5). O gerenciador atual não possui sistema
    // de avaliações; se um dia o produto trouxer avaliacao/rating/nota, as
    // estrelas passam a aparecer automaticamente.
    // Média real das avaliações gravadas no servidor (api/avaliacoes_resumo.php, carregada em
    // App.vue); se o produto não tiver nenhuma, usa o campo avaliacao/rating/nota do produto.
    resumoAvaliacao() {
      const mapa = this.$store.state.avaliacoesResumo || {};
      const r = this.product ? mapa[String(this.product.id)] : null;
      return r && Number(r.total) > 0 ? r : null;
    },
    totalAvaliacoes() {
      return this.resumoAvaliacao ? Number(this.resumoAvaliacao.total) : 0;
    },
    notaAvaliacao() {
      if (this.resumoAvaliacao) {
        const m = parseFloat(this.resumoAvaliacao.media);
        return isNaN(m) ? 0 : Math.max(0, Math.min(5, m));
      }
      const bruto = this.product
        ? this.product.avaliacao ?? this.product.rating ?? this.product.nota
        : 0;
      const n = parseFloat(bruto);
      return isNaN(n) ? 0 : Math.max(0, Math.min(5, n));
    },
    // Endereço da página de detalhes deste produto (para compartilhar).
    urlProduto() {
      try {
        const r = this.$router.resolve({ name: "product", params: { id: this.product.id } });
        return window.location.origin + r.href;
      } catch (e) {
        return window.location.href;
      }
    },
    clienteLogado(){
      return this.$util.clienteLogado()
    },
    // Condições de venda do produto (Pix, parcelas, frete grátis, preço "DE"...), da Precificação.
    cond() {
      return calcularCondicoes(this.$store.state.condicoesVenda, this.product || {});
    },
    // Texto da faixa superior do card: desconto sobre o preço "DE" ou, na falta dele, o do Pix/Boleto.
    faixaDesconto() {
      if (!this.product || !(this.product.estoque > 0) || !this.exibirPreco) return null;
      const c = this.cond;
      if (c.descontoPercent > 0) return { percent: c.descontoPercent, extra: "" };
      if (c.pixPercent > 0) {
        const p = Math.round(c.pixPercent * 100) / 100;
        return { percent: String(p).replace(".", ","), extra: "no Pix ou boleto" };
      }
      return null;
    },
    exibirPreco() {
      const configuracoes = this.$store.state.configuracoesSite;
      const ocultarPrecoNaoLogado = configuracoes?.ocultar_preco_nao_logado || false;
      const clienteLogado = this.clienteLogado;
      
      console.log("[DEBUG Product] Configurações:", configuracoes);
      console.log("[DEBUG Product] ocultar_preco_nao_logado:", ocultarPrecoNaoLogado);
      console.log("[DEBUG Product] clienteLogado:", clienteLogado);
      console.log("[DEBUG Product] Deve exibir preço:", !(ocultarPrecoNaoLogado && !clienteLogado));
      
      if (ocultarPrecoNaoLogado && !clienteLogado) {
        return false;
      }
      return true;
    },
    imagem() {
      // Prioriza imagens que já vêm no objeto do produto (nova estrutura)
      if (this.product.imagens && this.product.imagens.length > 0) {
        return { base64: this.product.imagens[0] };
      }
      
      // Fallback para o store global (estrutura antiga)
      if (!this.$store?.state?.imagensDeProduto?.data?.length) return { base64: "/assets/loading2.gif" };
      let imagens = this.$store.state.imagensDeProduto.data.filter(
        (i) => i.produto === this.product.id
      );
      if (!imagens.length) return { base64: "/assets/loading2.gif" };
      let img = imagens[0];
      if (!img.base64) {
        img.base64 = "/assets/loading2.gif";
      }
      return img;
    },
    // Reflete se este produto já está na Lista de Desejos, para pintar o
    // coração preenchido (vermelho) e alternar o título/aria-label do botão.
    emDesejos() {
      const id = String(this.product?.id ?? "");
      return (this.$store.state.desejos || []).some((desejoId) => String(desejoId) === id);
    },
  },
  mounted() {
    this.getImage();
    // Modo Edição do Personalizar: o clique no "Adicionar" é interceptado (só seleciona o elemento);
    // App.vue avisa com este evento para abrir o balão "Escolha a tensão" e permitir selecioná-lo.
    this.$el.addEventListener("mx3-abrir-balao-tensao", this.abrirBalaoTensaoEdicao);
  },
  beforeDestroy() {
    if (this.$el) this.$el.removeEventListener("mx3-abrir-balao-tensao", this.abrirBalaoTensaoEdicao);
    this.limparTimerBalaoTensao();
    this.pararRastreioBalaoTensao();
  },
  methods: {
    onImageError(event) {
      event.target.src = "/assets/loading2.gif";
    },
    // Alterna o produto na Lista de Desejos: adiciona se ainda não estiver
    // lá, remove se já estiver (o mesmo botão de coração serve para as duas
    // ações, inclusive dentro da própria página /wishlist). A persistência
    // em localStorage ("itensDesejo") já é feita globalmente pelo watcher
    // de $store.state.desejos em App.vue.
    toggleWishlist(product) {
      // A lista é vinculada à conta; não cria um favorito local de visitante.
      if (!localStorage.getItem("accessToken")) {
        this.$router.push({ path: "/login", query: { redirect: this.$route.fullPath } });
        return;
      }
      const id = String(product?.id ?? "");
      const indice = (this.$store.state.desejos || []).findIndex(
        (desejoId) => String(desejoId) === id
      );
      if (indice === -1) {
        this.$store.state.desejos.push(id);
      } else {
        this.$store.state.desejos.splice(indice, 1);
      }
    },
    incrementQty() {
      const max = Number(this.product.estoque) || 1;
      if (this.qty < max) this.qty++;
    },
    decrementQty() {
      if (this.qty > 1) this.qty--;
    },
    // Mantém a quantidade digitada entre 1 e o estoque disponível.
    normalizarQty() {
      const max = Number(this.product.estoque) || 1;
      let n = parseInt(this.qty, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > max) n = max;
      this.qty = n;
    },
    rotuloDaTensao(valor) {
      return formatarRotuloTensao(valor);
    },
    // Botão "Adicionar": produto nas duas tensões pergunta a tensão antes; os demais adicionam direto.
    addCart(product, ev) {
      if ((product.tensoes || []).length > 1) {
        if (ev && typeof ev.clientX === "number") this._pontoMouse = { x: ev.clientX, y: ev.clientY };
        this.abrirBalaoTensao();
        return;
      }
      this.adicionarAoCarrinho(product);
    },
    // Balão "Escolha a tensão": fica aberto pelo tempo ajustado no Personalizar (padrão 3 s).
    // Enquanto o mouse estiver sobre o balão, o botão "Adicionar" ou o grupo "- 1 +", não fecha;
    // quando o mouse sai dessas áreas, a contagem recomeça do zero.
    // A posição do mouse é acompanhada pela página inteira (funciona também com o "-" desativado,
    // que não recebe eventos de mouse, e quando o balão cobre parte dos botões).
    // No Modo Edição do Personalizar fica aberto até ser fechado (para poder ser selecionado).
    abrirBalaoTensao() {
      this.escolhendoTensao = true;
      this.iniciarRastreioBalaoTensao();
      this.$nextTick(() => {
        this._mouseSobreBalaoTensao = this.mouseNasAreasDoBalao();
        if (this._mouseSobreBalaoTensao) this.limparTimerBalaoTensao();
        else this.agendarFechamentoBalaoTensao();
      });
    },
    abrirBalaoTensaoEdicao() {
      if (!((this.product && this.product.tensoes) || []).length || this.product.tensoes.length < 2) return;
      if (!(this.product.estoque > 0)) return;
      this.limparTimerBalaoTensao();
      this.escolhendoTensao = true;
    },
    areasDoBalaoTensao() {
      const r = this.$refs || {};
      const btn = r.btnAdicionar && (r.btnAdicionar.$el || r.btnAdicionar);
      return [r.balaoTensao, btn, r.qtyControl].filter((el) => el && el.getBoundingClientRect);
    },
    mouseNasAreasDoBalao() {
      const p = this._pontoMouse;
      if (!p) return false;
      return this.areasDoBalaoTensao().some((el) => {
        const b = el.getBoundingClientRect();
        return b.width > 0 && p.x >= b.left - 1 && p.x <= b.right + 1 && p.y >= b.top - 1 && p.y <= b.bottom + 1;
      });
    },
    iniciarRastreioBalaoTensao() {
      if (this._rastreioBalao || typeof document === "undefined") return;
      this._rastreioBalao = (e) => {
        if (e.pointerType && e.pointerType !== "mouse") return;
        this._pontoMouse = { x: e.clientX, y: e.clientY };
        if (!this.escolhendoTensao) return;
        const dentro = this.mouseNasAreasDoBalao();
        if (dentro && !this._mouseSobreBalaoTensao) this.limparTimerBalaoTensao();
        else if (!dentro && this._mouseSobreBalaoTensao) this.agendarFechamentoBalaoTensao();
        this._mouseSobreBalaoTensao = dentro;
      };
      document.addEventListener("pointermove", this._rastreioBalao, { passive: true });
    },
    pararRastreioBalaoTensao() {
      if (this._rastreioBalao) document.removeEventListener("pointermove", this._rastreioBalao);
      this._rastreioBalao = null;
      this._mouseSobreBalaoTensao = false;
    },
    agendarFechamentoBalaoTensao() {
      this.limparTimerBalaoTensao();
      if (!this.escolhendoTensao || modoEdicaoAtivo()) return;
      this._timerBalaoTensao = setTimeout(() => {
        this._timerBalaoTensao = null;
        if (modoEdicaoAtivo()) return;
        if (this.mouseNasAreasDoBalao()) { this._mouseSobreBalaoTensao = true; return; }
        this.fecharBalaoTensao();
      }, duracaoBalaoTensao());
    },
    limparTimerBalaoTensao() {
      if (this._timerBalaoTensao) {
        clearTimeout(this._timerBalaoTensao);
        this._timerBalaoTensao = null;
      }
    },
    fecharBalaoTensao() {
      this.limparTimerBalaoTensao();
      this.pararRastreioBalaoTensao();
      this.escolhendoTensao = false;
    },
    confirmarTensao(tensao) {
      this.fecharBalaoTensao();
      this.adicionarAoCarrinho(aplicarTensao(this.product, tensao));
    },
    // `product` já vem com preço/estoque da tensão escolhida (quando houver).
    adicionarAoCarrinho(product) {
      const estoque = Number(product.estoque) || 0;
      let qtd = parseInt(this.qty, 10);
      if (isNaN(qtd) || qtd < 1) qtd = 1;
      if (estoque > 0 && qtd > estoque) qtd = estoque;
      const jaNoCarrinho = this.$store.state.carrinho.some(
        (id) => String(id) === String(product.id)
      );
      // Já no carrinho em OUTRA tensão: o item passa para a tensão escolhida e a quantidade é a escolhida agora.
      const guardada = carrinhoTensao.get(product.id);
      const trocouTensao = jaNoCarrinho && !!guardada && !!product.tensaoSelecionada && guardada !== product.tensaoSelecionada;
      // Produto nas duas tensões: o carrinho guarda a tensão escolhida.
      registrarTensaoNoCarrinho(product);
      if (jaNoCarrinho && !trocouTensao) {
        // Produto já no carrinho: soma a quantidade escolhida, respeitando o estoque.
        const atual = carrinhoQtd.get(product.id);
        let novo = atual + qtd;
        if (estoque > 0 && novo > estoque) novo = estoque;
        carrinhoQtd.set(product.id, novo);
      } else {
        // A quantidade é gravada antes do push para o carrinho já abrir correto.
        carrinhoQtd.set(product.id, qtd);
        if (!jaNoCarrinho) this.$store.state.carrinho.push(product.id);
      }
      avisarAdicionadoAoCarrinho({
        imgEl: this.$el && this.$el.querySelector(".product-image img"),
        nome: product.nome,
        tensao: product.tensaoSelecionada ? formatarRotuloTensao(product.tensaoSelecionada) : "",
        qtd,
        router: this.$router,
      });
      this.qty = 1;
      this.$forceUpdate();
    },
    notificarDisponibilidade() {
      const cliente = this.$store.state.cliente || {};
      const nomeCliente = cliente.nome || "";
      const emailCliente = cliente.email || "";
      const mensagemPadrao = `Olá, gostaria de ser notificado quando o produto "${this.product.nome}" estiver disponível em estoque. ${nomeCliente ? 'Meu nome é ' + nomeCliente : ''} ${emailCliente ? 'e meu e-mail é ' + emailCliente : ''}.`;
      
      localStorage.setItem("contato_mensagem_padrao", mensagemPadrao);
      this.$router.push({ name: 'contato' });
    },
    openProduct() {
      localStorage.setItem("productNameMeta", this.product.nome);
      this.$router.push({
        name: 'product',
        params: { id: this.product.id }
      });
    },
    // Estrelas do card: abre o produto direto na aba "Avaliações".
    openProductReviews() {
      localStorage.setItem("productNameMeta", this.product.nome);
      this.$router.push({
        name: 'product',
        params: { id: this.product.id },
        query: { aba: 'avaliacoes' }
      });
    },
    // O aviso "Faça login para ver o preço" leva direto à tela de login,
    // em vez de abrir o produto (que continuaria sem mostrar o preço).
    irParaLogin() {
      if (this.$route && this.$route.path === '/login') return;
      this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } });
    },
    getImage() {},
  },
};
</script>

<style lang="scss">

@media (max-width: 768px) {

  #img-produto-card-list {
    height: 70px !important;
  }
  #products-container-custom {
    width: 100% !important;
    max-width: 100% !important;
  }
  .product-showcase  {
    margin-top: 0 !important;
    h4{
      font-size: 6px !important; /* AJUSTE: Padronizado para 6px */
      padding: 2px 3px !important;
    }
    h6{
      font-size: 6px !important; /* AJUSTE: Padronizado para 6px */
      padding: 2px 3px !important;
    }
  }
  .produto-card-custom{
    padding:0px !important;
    padding-bottom: 0px !important;
  }

  /* CORREÇÃO 2.3: Título do produto com altura ajustada para acomodar textos reduzidos */
  /* AJUSTE: Padronizar para 6px conforme solicitado */
  h6.product-title {
    min-height: 42px !important;
    max-height: 42px !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 6 !important;
    -webkit-box-orient: vertical !important;
    text-overflow: ellipsis !important;
    font-size: 6px !important; /* Padronizado para 6px */
    line-height: 1.2 !important;
    padding: 3px 3px 3px 3px !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
  }
  
  .product-showcase h6.product-title {
    min-height: 42px !important;
    max-height: 42px !important;
    -webkit-line-clamp: 6 !important;
  }

  /* Mobile: espaço ZERO entre título e linha separadora */
  .divider-line {
    margin: 0 3px 0 3px !important;
    width: calc(100% - 6px) !important;
    flex-shrink: 0 !important;
    height: 1px !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  /* CORREÇÃO 2.3: Padronizar textos de status e preço para 6px com espaçamento simétrico */
  /* Seletores de altíssima especificidade para mobile */
  .produto-card-custom .product-details {
    padding-top: 6px !important; /* Espaçamento uniforme no topo */
  }
  .produto-card-custom .status-text, 
  .produto-card-custom .product-details .status-text,
  .produto-card-custom .text-danger.status-text,
  .produto-card-custom div.status-text,
  .produto-card-custom span.status-text {
    font-size: 6px !important;
    padding: 4px 3px !important;
    min-height: 22px !important; /* Igualado ao price-display para manter cards do mesmo tamanho no mobile */
    line-height: 1 !important;
    margin: 0 !important;
    margin-top: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: auto !important;
    flex-grow: 1 !important; /* Ocupa o mesmo espaço que o price-display */
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .produto-card-custom .price-display,
  .produto-card-custom div.price-display {
    padding: 4px 3px !important;
    margin: 0 !important;
    margin-top: 0 !important;
    font-size: 6px !important;
    min-height: 22px !important; /* Altura padronizada para mobile */
    flex-grow: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1 !important;
  }
  .price-display h4 {
    font-size: 6px !important; /* Padronizado para 6px */
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .price-display h4 small {
    font-size: 6px !important; /* Texto 'Faça login para ver o preço' - Padronizado para 6px */
    padding: 0 !important;
    margin: 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .price-display h4 b {
    font-size: 6px !important;
  }
  #buy-button-{
    width: 100% !important;
    scale: 1;
    margin-top: 0 !important;
    padding: 0 !important;
  }
  
  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  
  .btn-adicionar-card {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 4px !important;
    min-height: unset !important;
    height: 22px !important;
    line-height: 1 !important;
  }

  .btn-adicionar-card small {
    font-size: 0.75rem !important;
  }
  .product-image{
    padding: 10px !important;
  }
  
  /* Estílo Botão Avise-me no Card (Mobile) */
  .btn-avise-me-card {
    border: 1px solid var(--mx3-style-primary, #ff6600) !important;
    background: rgba(255, 102, 0, 0.1) !important;
    color: var(--mx3-style-primary, #ff6600) !important;
    font-weight: 600 !important;
    padding: 0 !important;
    height: 22px !important;
    max-height: 22px !important;
    line-height: 1 !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 0.72rem !important; /* Tamanho reduzido para mobile */
    border-radius: 4px !important; /* Padronizado para 4px */
    width: 100% !important;
    margin: 0 !important;
    min-height: 22px !important;
  }
  
  .btn-wrapper-avise-me .btn-avise-me-card {
    height: 22px !important;
    max-height: 22px !important;
    min-height: 22px !important;
  }
  
  .produto-card-custom .btn-avise-me-card {
    height: 22px !important;
    max-height: 22px !important;
    min-height: 22px !important;
  }
  
  .btn-avise-me-card:hover {
    background: rgba(255, 102, 0, 0.1) !important;
    color: #ffffff !important;
  }
  
  .btn-avise-me-card .btn-text-adicionar span {
    font-size: 6px !important;
  }
}

/* Estílo Botão Avise-me no Card (Desktop) */
.btn-avise-me-card {
  border: 1px solid var(--mx3-style-primary, #ff6600) !important;
  background: rgba(255, 102, 0, 0.1) !important;
  color: var(--mx3-style-primary, #ff6600) !important;
  font-weight: 600 !important;
  padding: 6px 0 !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 0.85rem !important;
  border-radius: 6px !important;
  width: 100% !important;
  margin: 0 !important;
  min-height: 28px !important;
  height: auto !important;
  line-height: 1.2 !important;
}

.btn-avise-me-card:hover {
  background: rgba(255, 102, 0, 0.1) !important;
  color: #ffffff !important;
}




.cursor-pointer {
  cursor: pointer;
}
.buttons-product-card {
}
.call-to-action .product-showcase {
  background: transparent !important;
}
.call-to-action .product-showcase .buttons-product-card {
  display: flex;
  justify-content: center; /* opcional: centraliza horizontal */
  align-items: flex-end; /* joga a filha para baixo */
}

#img-produto-card-list {
  object-fit: contain !important;
  background: transparent;
  border-radius: 0px !important;
}
/* Celular: cantos externos do grupo "- 1 +  Adicionar" menos arredondados (4px), em harmonia com o raio do card (8px). */
@media (max-width: 768px) {
  html:not(#mx3a):not(#mx3b):not(#mx3c) body .produto-card-custom .btn-wrapper-adicionar .btn-adicionar-card {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }
  html:not(#mx3a):not(#mx3b):not(#mx3c) body .produto-card-custom .btn-wrapper-adicionar .quantity-control {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  html:not(#mx3a):not(#mx3b):not(#mx3c) body .produto-card-custom .btn-wrapper-adicionar .qty-btn.qty-minus {
    border-top-left-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
  }
}
/* Um só fundo atrás da foto: o do QUADRO da imagem (.product-image). A foto não pinta fundo próprio - senão,
   quando ela não preenche o quadro (ou ao deslocá-la), aparecem dois tons diferentes que somem ao passar o
   mouse (a foto aumenta e cobre o quadro). Especificidade alta para vencer ajustes antigos feitos na foto. */
html:not(#mx3a):not(#mx3b):not(#mx3c):not(#mx3d) body .produto-card-custom #img-produto-card-list,
html:not(#mx3a):not(#mx3b):not(#mx3c):not(#mx3d) body .produto-card-custom .product-image img {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}

@media (max-width: 768px) {
  #img-produto-card-list {
    object-fit: contain !important;
  }
}

.produto-card-custom {
  position: relative !important;
  background: #232323 !important;
  background-color: #232323 !important;
  border: 0.1px #afafaf30 solid !important;
  background: rgba(36, 36, 36, 0.8) !important;
  border-radius: 1rem !important;
  padding: 2.5rem 2rem;
  text-align: center !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  backdrop-filter: blur(10px) !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  min-height: 100% !important;
}

.produto-card-custom:hover {
  transform: translateY(-10px) !important;
  border-color: #ff660050 !important;
  background: rgba(36, 36, 36, 0.95) !important;
  box-shadow: 0 20px 40px rgba(255, 102, 0, 0.3),
    0 0 60px rgba(255, 102, 0, 0.1) !important;
}

.product-image {
  flex-shrink: 0 !important;
}

#img-produto-card-list {
  height: 180px;
  width: 100% !important;
  margin-bottom: 10px !important;
}

/* Linha de ação rápida (coração da Lista de Desejos). Fica em sua própria
   linha, entre o título e o preço - nunca sobre a imagem do produto. A
   altura da linha é sempre reservada (evita o card "pular" quando o
   coração aparece/some), mas o botão em si só fica visível ao passar o
   mouse sobre o card (.produto-card-custom:hover). Em telas de toque, que
   não têm hover, ele permanece sempre visível - senão o recurso ficaria
   inacessível no celular. */
.card-quick-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 6;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: flex-start;
  align-items: flex-end;
  height: auto;
  padding: 0;
}

.wishlist-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid var(--mx3-style-border, rgba(255, 255, 255, 0.18));
  border-radius: 50%;
  /* Usa as variáveis de tema já definidas em main.css/main-light.css (o
     site troca a folha de estilo inteira ao alternar claro/escuro, ver
     ThemeSwitcher.vue - por isso aqui não se usa uma classe de tema, e
     sim as mesmas variáveis que cada folha já define com o valor certo
     para o seu próprio tema). */
  background: color-mix(in srgb, var(--mx3-style-bg-card, #1c1e20), transparent 25%);
  color: var(--default-color, #ffffff);
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: scale(0.85);
  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

/* Em desktop o coração só aparece enquanto o usuário passa o mouse sobre o card. */
@media (hover: hover) and (pointer: fine) {
  .produto-card-custom:hover .wishlist-toggle-btn,
  .produto-card-custom:focus-within .wishlist-toggle-btn {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .wishlist-toggle-btn {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }
  .card-quick-actions {
    top: 6px;
    right: 6px;
    gap: 4px;
  }
  .wishlist-toggle-btn {
    width: 20px;
    height: 20px;
    font-size: 0.7rem;
  }
}

.wishlist-toggle-btn:hover {
  transform: scale(1.1);
  border-color: #ff4d6d;
  color: #ff4d6d;
}

.wishlist-toggle-btn.is-active {
  background: rgba(255, 77, 109, 0.15);
  border-color: #ff4d6d;
  color: #ff4d6d;
}

.card-share-btn:hover { border-color: var(--mx3-style-primary, #ff6600); color: var(--mx3-style-primary, #ff6600); }
@media (hover: hover) and (pointer: fine) {
  .produto-card-custom:hover .card-share-btn,
  .produto-card-custom:focus-within .card-share-btn { opacity: 1; visibility: visible; transform: scale(1); }
}
.wishlist-toggle-btn.is-active:hover {
  color: #ff1f45;
}

.product-details {
  flex-grow: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  min-height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
}

.product-title {
  padding: 8px 8px 0 8px !important;
  margin: 0 !important;
  font-size: 0.85rem !important;
  line-height: 1.3 !important;
  min-height: 100px !important;
  max-height: 100px !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 10 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-break: break-word !important;
}

.divider-line {
  border-top: 0.1px solid #ffffff50 !important;
  margin: 2px 8px 0 8px !important;
  height: 0 !important;
  width: calc(100% - 16px) !important;
}

/* DESKTOP: Status e Preço com altura padronizada de 40px */
@media (min-width: 769px) {
  .product-details .status-text {
    padding: 8px 8px !important;
    margin: 0 !important;
    font-size: 0.85rem !important;
    min-height: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
    flex-grow: 0 !important;
    line-height: 1.4 !important;
  }

  .product-details .price-display {
    padding: 8px 8px !important;
    margin: 0 !important;
    flex-grow: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 40px !important;
    height: 40px !important;
    line-height: 1.4 !important;
  }

  .price-display h4 {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.85rem !important;
    line-height: 1.4 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .price-display h4 b {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4 !important;
  }

  .price-display h4 small {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.85rem !important;
    line-height: 1.4 !important;
  }

  /* Garantir que o h4 dentro de price-display respeite a altura total de 40px */
  .product-details .price-display h4 {
    height: 100% !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }

  /* Garantir que o status-text também respeite a altura total de 40px */
  .product-details .status-text {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }
}

/* MOBILE: Status e Preço com altura padronizada de 22px e fonte 6px */
@media (max-width: 768px) {
  .product-details .status-text {
    padding: 4px 3px !important;
    margin: 0 !important;
    font-size: 6px !important;
    min-height: 22px !important;
    height: 22px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
    flex-grow: 0 !important;
    line-height: 1 !important;
  }

  .product-details .price-display {
    padding: 4px 3px !important;
    margin: 0 !important;
    flex-grow: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 22px !important;
    height: 22px !important;
    line-height: 1 !important;
  }

  .price-display h4 {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 6px !important;
    line-height: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .price-display h4 b {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important;
    font-size: 6px !important;
  }

  .price-display h4 small {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 6px !important;
    line-height: 1 !important;
  }
}

.price-section {
  border-top: 0.1px solid #ffffff50 !important;
  padding: 8px 0 !important;
  margin: 0 !important;
}

/* Melhoria 3: Botão Adicionar alinhado com o fundo da imagem do produto */
.btn-container-adicionar {
  padding: 0 !important;
  width: 100% !important;
  overflow: visible !important;
  margin: 0 !important;
}

.btn-container-wrapper {
  width: 100% !important;
  padding: 0 8px 8px 8px !important;
  display: flex !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  margin-top: auto !important;
}

.btn-wrapper-adicionar {
  width: 100% !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  margin: 0 !important;
}

.btn-adicionar-card {
  width: 100% !important;
  margin: 0 !important;
  padding: 6px 0 !important;
  height: auto !important;
  min-height: 28px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-adicionar-card .btn-text-adicionar {
  font-size: 0.85rem !important;
}

/* Desktop: Alinhar botao com moldura da imagem */
@media (min-width: 769px) {
  .btn-container-wrapper {
    width: calc(100% + 4rem) !important;
    margin: 0 -2rem 0 -2rem !important;
    padding: 8px 2rem 0 2rem !important;
    display: flex !important;
    justify-content: center !important;
  }

  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
  }

  .btn-adicionar-card {
    min-height: 28px !important;
    padding: 6px 0 !important;
    height: auto !important;
    line-height: 1.2 !important;
    border-radius: 6px !important;
  }
}

/* Mobile: Achatar botão e adicionar padding inferior para não vazar do card */
@media (max-width: 768px) {
  .btn-container-wrapper {
    padding: 4px 10px 6px 10px !important;
  }

  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
  }

  .btn-adicionar-card {
    min-height: unset !important;
    height: 22px !important;
    padding: 0 0 !important;
    line-height: 1 !important;
    border-radius: 4px !important;
    font-size: 0.75rem !important;
  }

  .btn-adicionar-card .btn-text-adicionar {
    font-size: 0.72rem !important;
    gap: 3px !important;
  }

  .btn-adicionar-card .btn-text-adicionar svg {
    width: 12px !important;
    height: 12px !important;
  }
}

/* Aviso "Faça login para ver o preço" no card: apenas indica que é
   clicável, sem alterar a aparência original (sem sublinhado). */
.mx3-login-price-link{cursor:pointer}

/* Espaços reservados (categoria / estrelas = elementos v-else do template): usam as MESMAS classes do conteúdo
   real, então têm a mesma altura em qualquer tema/tamanho de tela, mas ficam invisíveis e sem clique -
   cards com e sem avaliação ficam exatamente do mesmo tamanho. */
.produto-card-custom .mx3-card-ph {
  visibility: hidden !important;
  pointer-events: none !important;
  user-select: none;
}

/* Estrelas do card clicáveis (levam à aba Avaliações do produto) */
.produto-card-custom .card-rating.card-rating-link {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font: inherit;
}
.produto-card-custom .card-rating.card-rating-link:hover i { transform: scale(1.15); }
.produto-card-custom .card-rating.card-rating-link i { transition: transform .15s ease; }
.produto-card-custom .card-rating .card-rating-count {
  margin-left: 4px;
  font-size: 11px;
  opacity: .75;
}

/* ===== Condições de venda no card (Precificação > Condições de Venda) =====
   Cores e tamanhos podem ser ajustados em Personalizar > Cards de produto. */
.produto-card-custom { position: relative; }
.produto-card-custom .product-image { position: relative; }
.produto-card-custom .mx3-card-ribbon {
  position: absolute; top: 8px; left: -4px; z-index: 5;
  display: flex; align-items: baseline; flex-wrap: wrap; gap: 3px;
  max-width: 78%; padding: 3px 12px 3px 8px;
  background: linear-gradient(135deg, var(--mx3-style-primary, #ff6600) 0, var(--mx3-style-primary-dark, #cc5200) 100%);
  color: #fff; font-weight: 800; line-height: 1.15; letter-spacing: .2px;
  clip-path: polygon(0 0, 100% 0, calc(100% - 8px) 50%, 100% 100%, 0 100%);
  box-shadow: 0 2px 6px rgba(0,0,0,.3); cursor: pointer; font-size: 11px;
}
.produto-card-custom .mx3-card-ribbon-pct { font-size: 1.25em; }
.produto-card-custom .mx3-card-ribbon-txt { font-size: .85em; }
.produto-card-custom .mx3-card-ribbon-extra { flex-basis: 100%; font-size: .72em; font-weight: 600; text-transform: none; opacity: .95; }
.produto-card-custom .mx3-card-badges {
  position: absolute; left: 6px; bottom: 6px; z-index: 4;
  display: flex; flex-direction: column; align-items: flex-start; gap: 3px; pointer-events: none;
}
.produto-card-custom .mx3-card-badge {
  display: inline-flex; align-items: center; gap: 4px; padding: 2px 7px; border-radius: 4px;
  font-size: 10px; font-weight: 700; line-height: 1.3; color: #fff; white-space: nowrap;
  box-shadow: 0 1px 4px rgba(0,0,0,.35);
}
.produto-card-custom .mx3-card-badge-express { background: #1e6fd9; }
.produto-card-custom .mx3-card-badge-free { background: #1f9d55; }
.produto-card-custom .mx3-card-old {
  display: flex; align-items: center; justify-content: center; flex-wrap: nowrap; gap: 6px; padding: 4px 6px 0; cursor: pointer;
  font-size: 11px; line-height: 1.2;
}
.produto-card-custom .mx3-card-old-price { min-width: 0; text-align: center; overflow-wrap: break-word; color: var(--mx3-style-text-muted, #9aa0a6); text-decoration: line-through; }
.produto-card-custom .mx3-card-off {
  display: inline-flex; align-items: center; gap: 1px; padding: 1px 6px; border-radius: 10px; white-space: nowrap; flex-shrink: 0;
  background: #1f9d55; color: #fff; font-weight: 700; font-size: .95em;
}
.produto-card-custom .mx3-card-cur { font-size: .6em !important; font-weight: 600; margin-right: 3px !important; align-self: flex-start; }
.produto-card-custom .mx3-card-pay { text-align: center; padding: 0 6px 6px; cursor: pointer; line-height: 1.3; }
.produto-card-custom .mx3-card-pix { font-size: 11px; font-weight: 700; color: #1f9d55; }
.produto-card-custom .mx3-card-installments { font-size: 10.5px; color: var(--mx3-style-text-muted, #9aa0a6); }
.produto-card-custom .mx3-card-installments strong { color: inherit; font-weight: 700; }
@media (max-width: 768px) {
  .produto-card-custom .mx3-card-ribbon { top: 4px; padding: 2px 8px 2px 5px; font-size: 7px; }
  .produto-card-custom .mx3-card-badge { font-size: 6.5px; padding: 1px 4px; gap: 2px; }
  .produto-card-custom .mx3-card-old { font-size: 7px; gap: 3px; padding-top: 2px; }
  .produto-card-custom .mx3-card-pix { font-size: 7px; }
  .produto-card-custom .mx3-card-installments { font-size: 6.5px; }
  .produto-card-custom .mx3-card-pay { padding: 0 3px 3px; }
}

/* Escolha de tensão ao clicar em "Adicionar" (produto cadastrado em 110 V e 220 V): balão acima do botão.
   Todas as cores vêm das variáveis do tema ativo (claro/escuro): fundo = --surface-color, texto = --heading-color. */
.produto-card-custom .btn-wrapper-adicionar { position: relative; }
.mx3-card-voltpick {
  position: absolute; left: 0; right: 0; bottom: calc(100% + 8px); z-index: 20; padding: 8px 10px 10px; border-radius: 10px;
  color: var(--heading-color, #212529);
  background: var(--surface-color, #fff);
  border: 1px solid var(--mx3-style-primary, #ff6600);
  box-shadow: 0 8px 22px rgba(0, 0, 0, .28);
}
.mx3-card-voltpick::after {
  content: ""; position: absolute; left: 50%; bottom: -6px; width: 10px; height: 10px; margin-left: -5px; transform: rotate(45deg);
  background: var(--surface-color, #fff);
  border-right: 1px solid var(--mx3-style-primary, #ff6600); border-bottom: 1px solid var(--mx3-style-primary, #ff6600);
}
.mx3-card-voltpick-title { display: flex; align-items: center; justify-content: space-between; gap: 6px; font-size: .68rem; font-weight: 800; letter-spacing: .5px; text-transform: uppercase; margin-bottom: 8px; color: var(--heading-color, #212529); }
.mx3-card-voltpick-title i { color: var(--mx3-style-primary, #ff6600); }
.mx3-card-voltpick-x { border: 0; background: transparent; color: var(--default-color, #4a5568); font-size: 1.3rem; line-height: 1; padding: 0 4px; cursor: pointer; opacity: .75; }
.mx3-card-voltpick-x:hover { opacity: 1; color: var(--mx3-style-primary, #ff6600); }
.mx3-card-voltpick-opts { display: flex; gap: 8px; }
.mx3-card-voltpick-opt { flex: 1 1 0; min-width: 0; padding: 8px 4px; border-radius: 6px; cursor: pointer; font: inherit; font-size: .95rem; font-weight: 800; color: #000; border: 0;
  background: linear-gradient(135deg, var(--mx3-style-primary, #ff6600), var(--mx3-style-primary-dark, #cc5200)); }
.mx3-card-voltpick-opt:hover:not(:disabled) { filter: brightness(1.08); }
.mx3-card-voltpick-opt:disabled {
  opacity: 1; cursor: not-allowed; color: color-mix(in srgb, var(--default-color, #4a5568) 70%, transparent);
  background: color-mix(in srgb, var(--default-color, #4a5568) 14%, transparent);
  text-decoration: line-through;
}
</style>
